<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:areaHeader="{}">
        <el-dropdown trigger="click" :hide-on-click="false">
          <span class="el-dropdown-link">
            {{ $l('btn_region') || '区域'
            }}<i
              class="el-icon-arrow-down el-icon--right"
              style="font-weight:bold;"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="padding:10px;">
            <ul class="infinite-list">
              <li
                v-for="(itme, i) in areaList"
                :key="i"
                class="infinite-list-item"
              >
                <el-checkbox v-model="areas" :label="itme.label">{{
                  itme.label
                }}</el-checkbox>
              </li>
            </ul>
            <div class="mt-2" style="text-align:center">
              <el-button size="small" type="warning" @click="areaReset()">{{
                $l('INDEX.btn_reset') || '重置'
              }}</el-button>
              <el-button size="small" type="primary" @click="query()">{{
                $l('btn_filter') || '筛选'
              }}</el-button>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.dictStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.dictStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-button
            type="text"
            size="mini"
            v-if="allow('M')"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                params: row,
              })
            "
            >{{$l('INDEX.btn_tips_edit') || '编辑'}}</el-button
          >
          <el-button
            :disabled="row.dictStatus === 'N'"
            type="text"
            size="mini"
            @click="del(row.keyID)"
            v-if="allow('D')"
            >{{$l('INDEX.btn_tips_del') || 'del'}}</el-button
          >
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 90,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'dictValue',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_dict_value') || '业务字典编码',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'dictText',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_dict_text') || '业务字典中文显示文字',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'dictTextEn',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_dict_text_en') || '业务字典英文显示文字',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'dictStatus',
          align: 'center',
          width: 80,
          title: this.$l('table_label_status') || '有效状态',
          slots: { default: 'status' },
          filters: [
            {
              label: this.$l('INDEX.form_label_valid') || '有效',
              value: 'Y'
            },
            { label: this.$l('INDEX.form_label_invalid') || '无效', value: 'N' }
          ],
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.masterBizDictOptionsDelApi({ keyID: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    }
  }
}
</script>
